(function (angular) {
	'use strict';
	angular
		.module('PinMeTo.notifications')

		.component('pmtNotificationStatus', {
			templateUrl: 'pmtShared/notifications/pmtNotificationStatus.html',
			controller: NotificationStatus
		});

	NotificationStatus.$inject = ['$stateParams', 'auth', 'pmtNotificationService'];
	function NotificationStatus($stateParams, auth, pmtNotificationService) {
		var $ctrl = this;
		$ctrl.unread = 0;
		$ctrl.hasAlerts = false;

		auth.getUser($stateParams.site).then(function (user) {
			$ctrl.user = user;
			pmtNotificationService.subscribeToNotifications(function (notifications) {
				$ctrl.hasAlerts = notifications.some(function (n) {
					return n.type === 'alert';
				});
				$ctrl.unread = notifications.length;
			});
		});
	}
})(window.angular);
